<template>
  <div class="p-4">
    <!-- 获取建议关键字表单 -->
    <div class="mb-6 p-4 bg-white rounded-lg">
      <el-form
        ref="form"
        :model="form"
        :disabled="disabled"
        class="mb-4"
        label-width="120px"
        :rules="rules"
      >
        <el-form-item label="获取建议关键字">
          <el-input
            v-model="keywordForm.url"
            placeholder="https://x5nngo.com/detail/40Cql2nb6ZmhFbBGmh"
            class="w-80"
          />
        </el-form-item>
        <el-form-item>
          <div class="flex justify-between items-center">
            <div class="flex-1 mr-20">
              <el-input
                v-model="keywordForm.productName"
                @change="changeProductName"
                placeholder="请输入要宣传的产品名称"
                class="w-80"
              />
            </div>
            <el-button
              type="primary"
              @click="fetchKeywords"
              :loading="loading"
              :disabled="!hasNextPage"
              class="bg-blue-500 hover:bg-blue-600"
            >
              {{ buttonText }}
            </el-button>
          </div>
          <!-- <el-row :gutter="10">
            <el-col :span="16">
              <el-input
                v-model="keywordForm.productName"
                @change="changeProductName"
                placeholder="请输入要宣传的产品名称"
                class="w-80"
              />
            </el-col>
            <el-col
              :span="8"
              class="text-right"
              ><el-button
                type="primary"
                @click="fetchKeywords"
                :loading="loading"
                :disabled="!hasNextPage"
                class="bg-blue-500 hover:bg-blue-600"
              >
                {{ buttonText }}
              </el-button></el-col
            >
          </el-row> -->
          <p class="text-xs text-[#f00]">{{ error }}</p>
        </el-form-item>
        <el-form-item
          label="关键词"
          prop="keywords"
        >
          <el-input
            type="textarea"
            v-model="form.keywords"
            placeholder="请输入关键词，每行一个"
            :rows="10"
            @input="onKeywordsChange"
            @keydown="handleKeydown"
          />
        </el-form-item>

        <div
          class="errorMessages"
          v-if="errorMessages.length > 0"
        >
          <div class="bg-orange-50 border border-orange-200 rounded-lg p-4">
            <div class="flex items-center mb-4 justify-between">
              <div class="flex items-center">
                <i class="el-icon-warning text-orange-500 mr-2"></i>
                <span class="text-orange-700 font-medium">有问题的关键词</span>
              </div>
              <div>
                <el-button
                  size="mini"
                  type="success"
                  @click="acceptAllSuggestions"
                  >全部采纳</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="deleteAllErrors"
                  >全部删除</el-button
                >
              </div>
            </div>

            <el-table
              :data="parsedErrorMessages"
              border
              size="mini"
              class="w-full"
            >
              <el-table-column
                prop="lineNumber"
                label="索引"
                width="80"
                align="center"
              >
                <template slot-scope="scope"> 第{{ scope.row.lineNumber }}行 </template>
              </el-table-column>
              <el-table-column
                label="问题词汇"
                min-width="200"
              >
                <template slot-scope="scope">
                  <div class="text-red-500 font-medium mb-1">{{ scope.row.original }}</div>
                  <div class="text-gray-500 text-xs">{{ scope.row.reasons }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="suggestion"
                label="建议修正"
                min-width="200"
              >
                <template slot-scope="scope">
                  <span class="text-green-600 font-medium">{{ scope.row.suggestion }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="180"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="success"
                    @click="acceptSuggestion(scope.$index)"
                    >采纳修正</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="deleteError(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { messages } from '@/api/automaticRules';
import { getKeyword } from '@/api/google/create';
import { checkKeywords } from '../index';
export default {
  name: 'Keywords',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    bigData: {
      type: Object,
      default: () => ({}),
    },
    createAdAccount: {
      type: Object,
      default: () => ({}),
    },
    enumConstants: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        keywords: '',
        matchType: '',
        negativeKeywords: '',
      },
      keywordForm: {
        url: '',
        productName: '',
      },
      loading: false,
      error: '',
      nextPageToken: '',
      hasFetched: false,
      hasNextPage: true,
      accumulatedKeywords: [],
      errorMessages: [],
      rules: {
        keywords: [
          {
            required: true,
            message: '关键词不能为空',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (!value || !value.trim()) {
                callback();
                return;
              }
              const keywords = value.split('\n').filter(Boolean);
              const checkResult = checkKeywords(keywords);
              if (checkResult && checkResult.length > 0) {
                this.errorMessages = checkResult;
                callback('请修正错误关键字');
              } else {
                this.errorMessages = [];
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    // 组件挂载后再次初始化，确保数据正确显示
    this.$nextTick(() => {
      this.initData();
    });
  },
  watch: {
    bigData: {
      handler(newVal, oldVal) {
        // 只在真正需要时重置，避免影响分页
        if (oldVal && JSON.stringify(newVal?.promoteInfo) !== JSON.stringify(oldVal?.promoteInfo)) {
          this.$set(this, 'hasNextPage', true);
          this.$set(this, 'hasFetched', false);
          this.error = '';
          this.nextPageToken = '';
          this.accumulatedKeywords = [];
        }
        this.keywordForm.url = this.promoteInfo?.promotionLink || '';
      },
      deep: true,
      immediate: true,
    },
    value: {
      handler(val) {
        // 只有当数据真正变化时才重新初始化，避免循环更新
        if (val && val.keywordList) {
          const currentKeywords = this.form.keywords.split('\n').filter((k) => k.trim());
          const newKeywords = val.keywordList || [];
          if (JSON.stringify(currentKeywords) !== JSON.stringify(newKeywords)) {
            this.initData();
          }
        } else if (!this.form.keywords) {
          this.initData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    buttonText() {
      return this.hasFetched ? '换一批' : '获取关键字';
    },
    promoteInfo() {
      return this.bigData.promoteInfo || this.bigData.promotionInfo;
    },
    getKeywordPrams() {
      console.log(this.bigData, 'this.bigData.promoteInfo');
      let locationId =
        this.promoteInfo.locationId ||
        this.bigData.campaignCriterion.target?.locations?.[0]?.id ||
        this.bigData.campaignCriterion.target?.locations?.[0]?.criteria_id;
      let languageId = this.promoteInfo.languageId || this.bigData.campaignCriterion.target?.languages?.[0];
      return { locationId, languageId };
    },
    parsedErrorMessages() {
      return this.errorMessages.map((error) => {
        return {
          lineNumber: error.index + 1,
          original: error.original,
          reasons: error.reasons,
          suggestion: error.suggestion,
        };
      });
    },
  },
  methods: {
    setDefault() {
      this.$set(this, 'hasNextPage', true);
      this.$set(this, 'hasFetched', false);
      this.error = '';
      this.nextPageToken = '';
    },
    changeProductName() {
      // 产品名称改变时重置分页状态
      this.$set(this, 'hasNextPage', true);
      this.$set(this, 'hasFetched', false);
      this.error = '';
      this.nextPageToken = '';
      this.accumulatedKeywords = [];
    },
    // 返回的关键词只有我输入的关键词的时候
    onlyOneKeyword(keyword, keywordList) {
      return keywordList.length == 1 && keywordList.filter((item) => item.keyword === keyword).length === 1;
    },
    async fetchKeywords() {
      if (!this.keywordForm.url && !this.keywordForm.productName) {
        this.error = '请输入URL或产品名称';
        return;
      }

      this.loading = true;
      try {
        const params = {
          url: this.keywordForm.url,
          keyword: this.keywordForm.productName,
          accountId: this.createAdAccount.id,
          ...this.getKeywordPrams,
          pageSize: 10,
        };
        console.log(this.nextPageToken, 'nextPageToken');
        if (this.nextPageToken) {
          params.nextPageToken = this.nextPageToken;
        }

        const response = await getKeyword(params);
        console.log(response, 'response');
        if (response.data && response.data.keywordIdeas && response.data.keywordIdeas.length) {
          if (this.onlyOneKeyword(this.keywordForm.productName, response.data.keywordIdeas)) {
            this.error =
              '请先确认并统一投放地区和语言。建议等待获取到关键词后再修改语言。您也可以尝试输入产品名称重新获取。';
          }
          this.accumulatedKeywords = [...this.accumulatedKeywords, ...response.data.keywordIdeas];
          this.form.keywords = this.accumulatedKeywords.map((v) => v.keyword).join('\n');

          this.nextPageToken = response.data.nextPageToken || '';
          this.hasNextPage = !!response.data.nextPageToken;
          this.hasFetched = !!response.data.nextPageToken;

          this.$nextTick(() => {
            this.onKeywordsChange();
            console.log('BBBB', this.hasFetched, this.hasNextPage);
          });
        } else {
          this.error =
            '请先确认并统一投放地区和语言。建议等待获取到关键词后再修改语言。您也可以尝试输入产品名称重新获取。';
        }
      } catch (error) {
        this.error = '获取关键词失败，请稍后重试';
      } finally {
        this.loading = false;
      }
    },
    initData() {
      console.log('initData called with value:', this.value);
      if (this.value && this.value.keywordList && Array.isArray(this.value.keywordList)) {
        this.form.keywords = this.value.keywordList.join('\n');
        this.accumulatedKeywords = this.value.keywordList.map((k) => ({ keyword: k }));
      } else {
        this.form.keywords = '';
      }
      this.form.matchType = this.value?.matchType || '';
      this.form.negativeKeywords = this.value?.negativeKeywords || '';
    },
    onKeywordsChange() {
      const keywordList = this.form.keywords ? this.form.keywords.split('\n').filter((k) => k.trim()) : [];
      // 只有当keywordList真正发生变化时才触发事件
      const currentKeywords = this.value?.keywordList || [];
      if (JSON.stringify(keywordList) !== JSON.stringify(currentKeywords)) {
        this.$emit('input', {
          ...this.value,
          keywordList,
        });
      }
    },
    // 采纳单个建议
    acceptSuggestion(index) {
      const error = this.parsedErrorMessages[index];
      const keywords = this.form.keywords.split('\n');
      const lineIndex = parseInt(error.lineNumber) - 1;
      if (keywords[lineIndex]) {
        keywords[lineIndex] = error.suggestion;
        this.form.keywords = keywords.join('\n');
        this.errorMessages.splice(index, 1);
        this.onKeywordsChange();
      }
    },
    // 删除单个错误
    deleteError(index) {
      const error = this.parsedErrorMessages[index];
      const keywords = this.form.keywords.split('\n');
      const lineIndex = parseInt(error.lineNumber) - 1;
      keywords.splice(lineIndex, 1);
      this.form.keywords = keywords.join('\n');
      this.errorMessages.splice(index, 1);
      this.onKeywordsChange();
    },
    // 采纳所有建议
    acceptAllSuggestions() {
      const keywords = this.form.keywords.split('\n');
      this.parsedErrorMessages.forEach((error) => {
        const lineIndex = parseInt(error.lineNumber) - 1;
        if (keywords[lineIndex]) {
          keywords[lineIndex] = error.suggestion;
        }
      });
      this.form.keywords = keywords.join('\n');
      this.errorMessages = [];
      this.onKeywordsChange();
    },
    // 删除所有错误
    deleteAllErrors() {
      const keywords = this.form.keywords.split('\n');
      const linesToDelete = this.parsedErrorMessages
        .map((error) => parseInt(error.lineNumber) - 1)
        .sort((a, b) => b - a);
      linesToDelete.forEach((lineIndex) => {
        keywords.splice(lineIndex, 1);
      });
      this.form.keywords = keywords.join('\n');
      this.errorMessages = [];
      this.onKeywordsChange();
    },
    // 处理键盘事件
    handleKeydown(event) {
      // 允许所有键盘操作，包括回车换行
      return true;
    },
    // 对外提供的验证方法
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form?.validate((valid, fields) => {
          if (valid) {
            resolve(true);
          } else {
            const errors = Object.values(fields)
              .flat()
              .map((error) => error.message);
            reject(errors);
          }
        });
      });
    },
  },
};
</script>
